import ready from "../utils/ready";
import { attachTabs } from "../components/tabs";
import {
  $,
  $$
} from "../utils/selector";

// Init steps component
ready().then(() => {
  handleUniformAjax();

  attachTabs();
  var firstTab = $(document, 'div.tabs li');
  if (firstTab) {
    firstTab.click();
  }

  registerWebmanagerRadioHooks();
  displayCorrectWebmanagers();
  registerOtherUpsManufacturerHook();
  setOtherManufactuerActiveState();
});

function handleUniformAjax() {
  var form = $(document, 'form#bacsconf');
  var fields = {};
  form.querySelectorAll('[name]').forEach(function (field) {
    fields[field.name] = field;
  });

  // Displays all error messages and adds 'error' classes to the form fields with
  // failed validation
  var handleError = function (response) {
    if (!response) {
      console.log("Internal Error: empty Error callback!");
    }

    let focused = false;
    for (var key in response) {
      if (!response.hasOwnProperty(key)) {
        continue;
      }

      if (fields.hasOwnProperty(key)) {
        // In bulma a <form> control should be wrapped in a '.control' container
        var closestControl = fields[key].closest('.control');
        var feedback = (null != closestControl) ? closestControl.querySelector('p.invalid-feedback') : null;

        if (null != feedback) {
          let field = $(document, '[name="' + fields[key].name + '"]');
          if (null != field) {
            // In bulma a div with '.select' is wrapped around the <select> element
            if ('SELECT' == field.tagName) {
              field.parentNode.classList.add('is-danger');
            } else {
              field.classList.add('is-danger');
            }

            // Set focus to first failed field
            if (false == focused) {
              focused = true;
              field.focus();
            }
          }

          feedback.innerHTML = '<span class="icon"><i class="fas fa-exclamation-circle"></i></span>' +
            response[key];
          feedback.style.display = 'block';
        } else {
          // Add error to general form failures
          var message = document.getElementById('message');
          message.classList.remove('is-hidden');
          message.innerHTML += response[key].join('<br>');
        }
      }
    }
  };

  var onload = function (e) {
    if (e.target.status == 200) {
      if (form) {
        form.action = window.location;
        form.removeEventListener('submit', submit);
      }

      var btn = $(document, 'button[value="' + fields['direction'] + '"]');
      if (btn) {
        btn.click();
      }
    } else {
      handleError(JSON.parse(e.target.response));
    }
  };

  var submit = function (e) {
    e.preventDefault();
    fields['direction'] = form.submitValue;
    var request = new XMLHttpRequest();
    request.open('POST', e.target.action);
    request.setRequestHeader('Accept', 'application/json');
    request.onload = onload;
    request.send(new FormData(e.target));

    // Remove general 'error' messages of a possible previously failed validation.
    var message = document.getElementById('message');
    message.classList.add('is-hidden');
    message.innerHTML = '';
  };

  var submitClick = function (e) {
    form.submitValue = this.value;
  }

  form.addEventListener('submit', submit);
  var submitButtons = $$(form, 'button[name="direction"]');
  submitButtons.forEach(btn => {
    btn.addEventListener('click', submitClick);
  });
}

function getRadioVal(form, name) {
  var val;
  // get list of radio buttons with specified name
  var radios = form.elements[name];

  if (undefined == radios || null == radios) {
    return null;
  }

  // loop through list of radio buttons
  for (var i = 0, len = radios.length; i < len; i++) {
    if (radios[i].checked) { // radio checked?
      val = radios[i].value; // if so, hold its value in val
      break; // and break out of for loop
    }
  }
  return val; // return value of checked radio or undefined if none checked
}

function unfade(element) {
  var op = 0.1; // initial opacity
  element.style.display = 'flex';
  var timer = setInterval(function () {
    if (op >= 1) {
      clearInterval(timer);
    }
    element.style.opacity = op;
    element.style.filter = 'alpha(opacity=' + op * 100 + ")";
    op += op * 0.1;
  }, 10);
}

function fade(element) {
  var op = 1; // initial opacity
  var timer = setInterval(function () {
    if (op <= 0.1) {
      clearInterval(timer);
      element.style.display = 'none';
    }
    element.style.opacity = op;
    element.style.filter = 'alpha(opacity=' + op * 100 + ")";
    op -= op * 0.1;
  }, 10);
}

function displayCorrectWebmanagers() { //currentRadio) {
  var rad = document.getElementById('bacsconf').webManager;
  var selVal = getRadioVal(document.getElementById('bacsconf'), "webManager");

  if (undefined == rad) {
    return null;
  }

  for (var j = 0; j < rad.length; ++j) {
    var media = rad[j].closest('.media');

    if ('nil' != selVal &&
      'nil' != rad[j].value &&
      selVal != rad[j].value) {
      // hide all unselected, if something else than 'nil' is selected
      // never hide 'nil' itself
      if ('none' != media.style.display) {
        fade(media);
      }
    } else {
      // default: show webmanager
      if ('none' == media.style.display) {
        unfade(media);
      }
    }
  }
}

function registerWebmanagerRadioHooks() {
  var rad = document.getElementById('bacsconf').webManager;

  if (undefined == rad) {
    return null;
  }

  for (var i = 0; i < rad.length; ++i) {
    rad[i].addEventListener('change', function () {
      displayCorrectWebmanagers();
    });
  }
}

function setOtherManufactuerActiveState() {
  var textfield = document.getElementById('otherManufacturer');
  var selectbox = document.getElementById('upsDetailsManufacturer');

  if (null == textfield || null == selectbox) {
    return null;
  }

  var textLine = textfield.parentNode.parentNode.parentNode.parentNode;

  if (null == textLine) {
    return null;
  }

  if ("AAAOTHER" !== selectbox.value) {
    textLine.classList.add('is-hidden');
  } else {
    textLine.classList.remove('is-hidden');
  }

}

function registerOtherUpsManufacturerHook() {
  var selectbox = document.getElementById('upsDetailsManufacturer');

  if (undefined === selectbox || null === selectbox) {
    return null;
  }

  selectbox.addEventListener('change', function () {
    setOtherManufactuerActiveState();
  });
}
